import {
    ChangeDetectorRef,
    ElementRef,
    Inject,
    InjectionToken,
    Injector,
    Input,
    OnDestroy,
    OnInit,
    Renderer2,
    Sanitizer,
    SecurityContext,
    Directive,
} from '@angular/core';
import { ListData } from '../../list-data.service';
import { ProtocolIndependentPipe } from '@fi-shared/fi-pipes/protocol-independent.pipe';
import { GetPropertyByString } from '@fi-shared/fi-shared-services/extensions.service';
import { ItemsListRowComponent } from '../list-row.component';
import { FiDisplayType } from '@fi-shared/types/display-type';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { isFunction } from '@fi-shared/utils/is-function';
import { Subject } from 'rxjs';
import { ItemsListHeader } from '@fi-app/components/items-list/items-list-header';
import { DomSanitizer } from '@angular/platform-browser';

export const ItemsListRowItemBase_data = new InjectionToken('ItemsListRowItemBase_data');
export const ItemsListRowItemBase_parentData = new InjectionToken('ItemsListRowItemBase_parentData');
export const ItemsListRowItemBase_head = new InjectionToken('ItemsListRowItemBase_head');
export const ItemsListRowItemBase_ngModel = new InjectionToken<ListData<any>>('ItemsListRowItemBase_ngModel');

@Directive()
export class ItemsListRowItemBase implements OnInit, OnDestroy {
    @Input() data: any;
    @Input() parentData: any;
    @Input() head: ItemsListHeader;
    @Input() ngModel: ListData<any>;

    sanitizer: DomSanitizer;
    protocolIndependentPipe: ProtocolIndependentPipe;
    elementRef: ElementRef;
    renderer: Renderer2;
    stateService: FiStateService;
    cdr: ChangeDetectorRef;
    itemsListRowComponent: ItemsListRowComponent<any>;

    constructor(@Inject(Injector) public injector: Injector) {
        this.sanitizer = injector.get(DomSanitizer);
        this.protocolIndependentPipe = injector.get(ProtocolIndependentPipe);
        this.elementRef = injector.get(ElementRef);
        this.renderer = injector.get(Renderer2);
        this.stateService = injector.get(FiStateService);
        this.cdr = injector.get(ChangeDetectorRef);

        this.data = this.injector.get(ItemsListRowItemBase_data);
        this.parentData = this.injector.get(ItemsListRowItemBase_parentData);
        this.head = <any>this.injector.get(ItemsListRowItemBase_head);
        this.ngModel = this.injector.get(ItemsListRowItemBase_ngModel);
        this.itemsListRowComponent = this.injector.get(ItemsListRowComponent);
    }

    GetIconClass() {
        return isFunction(this.ngModel.IconClass) ? this.ngModel.IconClass(this.data) : this.ngModel.IconClass;
    }

    GetImage() {
        if (this.head.Properties.ExtraProperties) {
            const imageSrcAttribute =
                this.ngModel.DisplayType == FiDisplayType.Grid && this.head.Properties.ExtraProperties.ImgSrcLarge
                    ? this.head.Properties.ExtraProperties.ImgSrcLarge
                    : this.head.Properties.ExtraProperties.ImgSrc;
            if (imageSrcAttribute) {
                const data =
                    this.head.Properties.ExtraProperties.useParentDataForDisplay && this.parentData
                        ? this.parentData
                        : this.data;
                if (isFunction(imageSrcAttribute)) return (<any>imageSrcAttribute)(data);

                return GetPropertyByString(data, imageSrcAttribute);
            }
        }
    }

    getBackgroundImage() {
        return this.sanitizer.sanitize(
            SecurityContext.STYLE,
            'url("' + this.protocolIndependentPipe.transform(this.GetImage()) + '")',
        );
    }

    ngOnInit(): void {
        this.head.Properties.updateContent$.takeUntil(this.ngOnDestroy$).subscribe(() => this.cdr.markForCheck());
    }

    ngOnDestroy$ = new Subject<void>();

    ngOnDestroy() {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
